/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import {
  GenerateWorkOSAdminPortalLinkRequestBody,
  GenerateWorkOSAdminPortalLinkRequestBody$Outbound,
  GenerateWorkOSAdminPortalLinkRequestBody$outboundSchema,
} from "../components/generateworkosadminportallinkrequestbody.js";

export type GenerateWorkOSAdminPortalLinkSecurity = {
  sessionHeaderGramSession?: string | undefined;
};

export type GenerateWorkOSAdminPortalLinkRequest = {
  /**
   * Session header
   */
  gramSession?: string | undefined;
  generateWorkOSAdminPortalLinkRequestBody:
    GenerateWorkOSAdminPortalLinkRequestBody;
};

/** @internal */
export type GenerateWorkOSAdminPortalLinkSecurity$Outbound = {
  "session_header_Gram-Session"?: string | undefined;
};

/** @internal */
export const GenerateWorkOSAdminPortalLinkSecurity$outboundSchema:
  z.ZodMiniType<
    GenerateWorkOSAdminPortalLinkSecurity$Outbound,
    GenerateWorkOSAdminPortalLinkSecurity
  > = z.pipe(
    z.object({
      sessionHeaderGramSession: z.optional(z.string()),
    }),
    z.transform((v) => {
      return remap$(v, {
        sessionHeaderGramSession: "session_header_Gram-Session",
      });
    }),
  );

export function generateWorkOSAdminPortalLinkSecurityToJSON(
  generateWorkOSAdminPortalLinkSecurity: GenerateWorkOSAdminPortalLinkSecurity,
): string {
  return JSON.stringify(
    GenerateWorkOSAdminPortalLinkSecurity$outboundSchema.parse(
      generateWorkOSAdminPortalLinkSecurity,
    ),
  );
}

/** @internal */
export type GenerateWorkOSAdminPortalLinkRequest$Outbound = {
  "Gram-Session"?: string | undefined;
  GenerateWorkOSAdminPortalLinkRequestBody:
    GenerateWorkOSAdminPortalLinkRequestBody$Outbound;
};

/** @internal */
export const GenerateWorkOSAdminPortalLinkRequest$outboundSchema: z.ZodMiniType<
  GenerateWorkOSAdminPortalLinkRequest$Outbound,
  GenerateWorkOSAdminPortalLinkRequest
> = z.pipe(
  z.object({
    gramSession: z.optional(z.string()),
    generateWorkOSAdminPortalLinkRequestBody:
      GenerateWorkOSAdminPortalLinkRequestBody$outboundSchema,
  }),
  z.transform((v) => {
    return remap$(v, {
      gramSession: "Gram-Session",
      generateWorkOSAdminPortalLinkRequestBody:
        "GenerateWorkOSAdminPortalLinkRequestBody",
    });
  }),
);

export function generateWorkOSAdminPortalLinkRequestToJSON(
  generateWorkOSAdminPortalLinkRequest: GenerateWorkOSAdminPortalLinkRequest,
): string {
  return JSON.stringify(
    GenerateWorkOSAdminPortalLinkRequest$outboundSchema.parse(
      generateWorkOSAdminPortalLinkRequest,
    ),
  );
}
